module.exports = "<div class=\"tr-search tr-search_mselect\" id=searchInput> <input class=\"tr-search__input js-search-input\" name=searchName placeholder={{{placeholder}}}> <div class=\"js-search-clear tr-search__clear\"></div> </div>";


//////////////////
// WEBPACK FOOTER
// ../src/templates/searchBar.hbs
// module id = 718
// module chunks = 0